import { render } from "./AddBoitePostalePage.vue?vue&type=template&id=0fe67c34&ts=true"
import script from "./AddBoitePostalePage.vue?vue&type=script&lang=ts"
export * from "./AddBoitePostalePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__